import { put, call } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import {
    getStepSuccess, getStepFail,
    getStepsByCareerPathSuccess, getStepsByCareerPathFail,
    addStepSuccess, addStepFail,
    updateStepSuccess, updateStepFail,
    deleteStepSuccess, deleteStepFail,
    setStepLoading, getStepsByCareerPathRequest
} from '../actions/careerPathStepActions';
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from '../../../api';

export function* getStepSaga(action) {
    const { careerPathId, stepId } = action.payload;
    const url = `${API_BASE_URL}/api/career-paths/${careerPathId}/steps/${stepId}`;
    yield put(setStepLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getStepSuccess(resp.data));
    } catch (error) {
        yield put(getStepFail(error.message));
    } finally {
        yield put(setStepLoading(false));
    }
}

export function* getStepsByCareerPathSaga(action) {
    const token = sessionStorage.getItem('token');
    const { careerPathId } = action.payload;
    const url = `${API_BASE_URL}/api/career-paths/${careerPathId}/steps`;
    yield put(setStepLoading(true));
    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getStepsByCareerPathSuccess(resp.data));
    } catch (error) {
        yield put(getStepsByCareerPathFail(error.message));
    } finally {
        yield put(setStepLoading(false));
    }
}

export function* addStepSaga(action) {
    const { careerPathId, stepData } = action.payload;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const url  = `${API_BASE_URL}/api/career-paths/${careerPathId}/steps`;

    yield put(setStepLoading(true));
    try {
        // const resp = yield call(postRequest, { url, data: stepData });
        const resp = yield call(postRequest, { url, data: stepData, uid: uid, token: token });

        yield put(addStepSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: '', text: 'Étape ajoutée avec succès',
            timer: 2000, showConfirmButton: false
        });
        yield put(getStepsByCareerPathRequest(careerPathId));
    } catch (error) {
        yield put(addStepFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: '', text: "Erreur lors de l'ajout de l'étape",
            timer: 2000, showConfirmButton: false
        });
    } finally {
        yield put(setStepLoading(false));
    }
}

export function* updateStepSaga(action) {
    const { careerPathId, stepId, stepData } = action.payload;
    const url  = `${API_BASE_URL}/api/career-paths/${careerPathId}/steps/${stepId}`;
    yield put(setStepLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: stepData });
        yield put(updateStepSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: '', text: 'Étape mise à jour avec succès',
            timer: 2000, showConfirmButton: false
        });
    } catch (error) {
        yield put(updateStepFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: '', text: "Erreur lors de la mise à jour",
            timer: 2000, showConfirmButton: false
        });
    } finally {
        yield put(setStepLoading(false));
    }
}

export function* deleteStepSaga(action) {
    const { careerPathId, stepId } = action.payload;
    const url = `${API_BASE_URL}/api/career-paths/${careerPathId}/steps/${stepId}`;
    yield put(setStepLoading(true));
    try {
        yield call(deleteRequest, { url });
        yield put(deleteStepSuccess(stepId));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: 'Succès', text: 'Étape supprimée avec succès',
            timer: 2000, showConfirmButton: false
        });
    } catch (error) {
        const errorMessage = error.response?.data?.message
            || error.response?.data?.error
            || error.message
            || 'Erreur lors de la suppression';
        yield put(deleteStepFail(errorMessage));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: 'Erreur de suppression', text: errorMessage,
            confirmButtonText: 'OK', confirmButtonColor: '#d33'
        });
    } finally {
        yield put(setStepLoading(false));
    }
}